const initializePendo = (visitorId, visitorData) => {
  if (typeof window === 'undefined') return; // Only run in browser

  const pendoData = {
    visitor: {
      id: visitorId || "GUEST",
      email: visitorData.email || "",
      first_name: visitorData.firstName || "",
      signup_date: visitorData.signupDate || "",
      state: visitorData.state || "",
      joined_community_groups: visitorData.joinedCommunityGroups,
      listings_count: visitorData.listingsCount,
      purchases_count: visitorData.purchasesCount
    },
  };

  if (window.pendo && typeof window.pendo.updateOptions === 'function') {
    console.log('Updating Pendo visitor data');
    window.pendo.updateOptions(pendoData);
  } else {
    console.log('Initializing Pendo');
    (function (p, e, n, d, o) {
      var v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (w = 0, x = v.length; w < x; ++w)(
        function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push'](
                [m].concat([].slice.call(arguments, 0))
              );
            };
        }
      )(v[w]);
      y = e.createElement(n);
      y.async = !0;
      y.src = `https://cdn.pendo.io/agent/static/${process.env.REACT_APP_PENDO_KEY}/pendo.js`;
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');

    window.pendo.initialize(pendoData);
  }

  console.log('Pendo visitor data:', pendoData);
};
export default initializePendo;